export default __webpack_public_path__ + "static/media/rabbit_type_3_2.d5bb9ceb.svg";